// extracted by mini-css-extract-plugin
export default {"slide_wrap":"ClickSlider_slide_wrap__2Du8d","slide_prev_btn":"ClickSlider_slide_prev_btn__5RXhC","slide_next_btn":"ClickSlider_slide_next_btn__TbPOi"};